// src/lib/apiFetch.js
export async function apiFetch(url, options = {}) {
    const resp = await fetch(url, {
        credentials: "include",
        headers: { "Content-Type": "application/json", ...(options.headers || {}) },
        ...options,
    });

    if (resp.status === 401) {
        // Notify app: session is gone
        window.dispatchEvent(new CustomEvent("session-expired"));
    }
    return resp;
}
